import { useTheme } from '@mui/material';

export const BenefitProfileIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M46.783 47.833h-.233M35 38.43a21 21 0 0 1-18.9-2.473 2.334 2.334 0 0 0-3.127.443 16.334 16.334 0 0 0-3.64 10.267A2.333 2.333 0 0 0 11.667 49H35m11.667-11.667v-7m-7-11.666a11.667 11.667 0 1 1-23.334 0 11.667 11.667 0 0 1 23.334 0Z"
            />
        </svg>
    );
};
